import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import _ from "utilities/vendor/lodash/4.13.1/js/lodash.custom.min";
import "utilities/vendor/fetch/2.0.3/js/fetch";












const DOMAIN_PATTERN = /^https?:\/\/www(?:-(?:(?:dev(?:flex)?)|(?:qa)|(?:cert)|(?:p?review))\d?\.ecnp)?\.bankofamerica.com/gi;
const WEB_JCR_TOKEN_PATTERN = /\\?\{(JCR|GLOSSARY|FOOTNOTE)\|\|((?:(?:\{(?:(?:\{(?:[^{}])*\})|(?:[^{}]))*\})|(?:[^{}]))*)(?:\|\| *(freeform) *)*\}/g;
const DEFAULT_GATEWAY_URL = 'ogateway/public/v1/content';








async function getJCRManifest(name, spaParameters = {}, iswidget) {
  const { buildTimestamp, siteParams } = spaParameters;
  const widgetParam = spartaStoreUtility.getData('applicationContext');
  const isJcrManifestTimestamped = buildTimestamp;
  let isCacheRequired = false;
  let jcrManifestTimestamp = '';

  if (isJcrManifestTimestamped) {
    isCacheRequired = siteParams.env !== 'local';
    jcrManifestTimestamp = `-${buildTimestamp}`;
  }

  const jsonPath = `spa-assets/jcr-manifest${jcrManifestTimestamp}.json`;

  const jcrManifestEndpoint = (iswidget) ? `${spaParameters.siteParams.widgetAPIEndpoint}/spa/widgets/${widgetParam.name}/${widgetParam.version}/${jsonPath}` : `/${name}/${jsonPath}`;

  const manifest = await fetch(jcrManifestEndpoint, {

    ...isCacheRequired ? undefined : { cache: 'no-cache' },

    headers: {
      'content-type': 'application/json',
    },

  });

  return manifest.json();
}








function resolveEnvironmentVariableInUrl(url, environmentVariables) {
  const compiled = _.template(url, { interpolate: /\{([\s\S]+?)\}/g });
  return compiled(environmentVariables);
}








function getWebJcrPath(token, spaParameters, manifest) {
  const jcrToken = _.first(token);
  const [jcrTokenKey, jcrTokenHelperFlag = 'shield'] = _.map(_.split(token[2], '||'), _.trim);
  const environmentVariables = { ...spaParameters.siteParams, language: window.sparta.language };
  let url;

  if (jcrTokenHelperFlag === 'shield') {
    const { env: environment, gatewayUrl = DEFAULT_GATEWAY_URL, language, shieldHost } = environmentVariables;
    if (!shieldHost) {
      throw new Error(`'shieldHost' is not present in '${environment}' environment variables`);
    }
    const resolvedJcrTokenKey = resolveEnvironmentVariableInUrl(
      jcrTokenKey, environmentVariables,
    );
    const lang = /^(es|en)\.(.)*/.test(jcrTokenKey) ? '' : `${language}.`;
    url = new URL(`${gatewayUrl}?key=${lang}${resolvedJcrTokenKey}`, shieldHost);
  } else if (jcrTokenHelperFlag === 'freeform') {
    url = new URL(resolveEnvironmentVariableInUrl(jcrTokenKey, environmentVariables));
  } else {
    throw new Error(`Helper flag '${jcrTokenHelperFlag}' is not supported in JCR token: ${jcrToken}`);
  }

  url = escape(url.href).replace(/\//g, '-');
  let pathData = manifest.jcrs.find(obj => obj.path.includes(url));
  if (pathData) {
    pathData = _.mapValues(pathData, value => escape(value));
  }

  return pathData;
}














export async function resolveDataSources(name, dataSources) {


  const spaParameters = spartaStoreUtility.getData('spaParams') || spaParams;
  const isWidget = spartaStoreUtility.getData('isWidget');
  const manifest = await getJCRManifest(name, spaParameters, isWidget);

  const jcrs = {};

  Object.keys(dataSources).filter(key => dataSources[key]).forEach((key) => {
    const jcrTokens = new RegExp(WEB_JCR_TOKEN_PATTERN).exec(dataSources[key]);
    let pathData;
    if (jcrTokens) {
      pathData = getWebJcrPath(jcrTokens, spaParameters, manifest);
    } else {
      const formattedPath = dataSources[key]
        .replace('{language}', window.sparta.language)
        .replace(/\//g, '-')
        .replace(/.json$/, '');
      pathData = manifest.jcrs.find(obj => obj.path.includes(formattedPath));
    }

    if (pathData) {
      jcrs[key] = pathData.path.replace(DOMAIN_PATTERN, '').replace('http://localhost/', '/').replace(`/${spaParameters.siteName}/`, `/${name}/`);
      if (isWidget) {
        jcrs[key] = `${spaParameters.siteParams.widgetAPIEndpoint}/${jcrs[key]}`;
      }
    }
  });

  return Object.assign({}, dataSources, jcrs);
}